import {ListItem} from "../common/list-view/list-item";

/**
 * Classe représentant un barème (fiscal ou SNCF)
 */
export class Bareme implements ListItem {
    idBareme: number;
    idPrestation: number;
    dateAppli: Date;
    mini: number;
    maxi: number;
    constante?: number;
    taux: number;

    constructor(dto?: any) {
        if (dto) {
            Object.assign(this,dto);
        }
    }

    getKey(): number {
        return this.idBareme;
    }
}